import { useCallback, useEffect, useState } from "react";
import { FiEdit2, FiRefreshCw } from "react-icons/fi";
import Api from "../../Services/Api";
import FormularioComissao from "../../Formulario/FormularioComissao";
import SidebarAdmin from "../../menu/SidebarAdmin";
import Topbar from "../../menu/Topbar";
import Modal from "../LancarComissao/Modal";
import "./PedidosSaque.css";

const currencyFormatter = new Intl.NumberFormat("pt-BR", {
  style: "currency",
  currency: "BRL",
});

const dateFormatter = new Intl.DateTimeFormat("pt-BR", {
  timeZone: "America/Sao_Paulo",
});

const isRequestedWithdraw = (item) => {
  const status = String(item?.status || "").trim().toUpperCase();
  return (
    String(item?.origin || "").trim().toUpperCase() === "WITHDRAW" &&
    (status === "WITHDRAW_REQUESTED" || status === "REQUESTED")
  );
};

const formatDate = (value) => {
  if (!value) return "-";
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? "-" : dateFormatter.format(date);
};

const PedidosSaque = () => {
  const [menuClose, setMenuClose] = useState(false);
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [editing, setEditing] = useState(null);

  const loadRequests = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const { data } = await Api.get("/ledger-entries", {
        params: { origin: "WITHDRAW", status: "WITHDRAW_REQUESTED", limit: 5000 },
      });
      setRequests((Array.isArray(data) ? data : []).filter(isRequestedWithdraw));
    } catch (requestError) {
      console.error("Erro ao carregar pedidos de saque:", requestError);
      setError("Nao foi possivel carregar os pedidos de saque.");
      setRequests([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadRequests();
  }, [loadRequests]);

  return (
    <div className="app-container pedidos-saque-page">
      <SidebarAdmin close={menuClose} withdrawRequestsActive="active" />
      <main className="main-content">
        <Topbar page="Pedidos de saque" onToggleMenu={() => setMenuClose((value) => !value)} />

        <section className="withdraw-requests-content">
          <div className="withdraw-requests-heading">
            <div>
              <span className="withdraw-requests-kicker">Financeiro</span>
              <h1>Pedidos de saque</h1>
              <p>Saques solicitados pelos licenciados e ainda pendentes de tratativa.</p>
            </div>
            <button
              type="button"
              className="withdraw-refresh-button"
              onClick={loadRequests}
              disabled={loading}
            >
              <FiRefreshCw className={loading ? "is-spinning" : ""} />
              Atualizar
            </button>
          </div>

          {loading ? <div className="withdraw-requests-state">Carregando pedidos de saque...</div> : null}
          {!loading && error ? <div className="withdraw-requests-state is-error">{error}</div> : null}
          {!loading && !error && requests.length === 0 ? (
            <div className="withdraw-requests-state">Nenhum pedido de saque solicitado no momento.</div>
          ) : null}

          {!loading && !error && requests.length > 0 ? (
            <div className="withdraw-request-grid">
              {requests.map((request) => {
                const amount = Math.abs(Number(request.purchase_amount) || 0);
                return (
                  <article className="withdraw-request-card" key={request.id}>
                    <div className="withdraw-request-card-top">
                      <span className="withdraw-request-status">Saque solicitado</span>
                      <span className="withdraw-request-id">#{request.withdraw_request_id || request.id}</span>
                    </div>
                    <div className="withdraw-request-amount">{currencyFormatter.format(amount)}</div>
                    <div className="withdraw-request-licensed">
                      {request.user_name || "Licenciado nao identificado"}
                    </div>

                    <dl className="withdraw-request-details">
                      <div>
                        <dt>Data</dt>
                        <dd>{formatDate(request.entry_date || request.purchase_date || request.created_at)}</dd>
                      </div>
                      <div>
                        <dt>Nº compra</dt>
                        <dd>{request.order_number || "-"}</dd>
                      </div>
                      <div>
                        <dt>Cliente</dt>
                        <dd>{request.client_name || "-"}</dd>
                      </div>
                    </dl>

                    <button
                      type="button"
                      className="withdraw-edit-button"
                      onClick={() => setEditing(request)}
                    >
                      <FiEdit2 /> Editar lancamento
                    </button>
                  </article>
                );
              })}
            </div>
          ) : null}
        </section>
      </main>

      <Modal open={Boolean(editing)} title="Editar lancamento de saque" onClose={() => setEditing(null)}>
        {editing ? (
          <FormularioComissao
            modo="edit"
            editId={editing.id}
            itemInicial={editing}
            onClose={() => setEditing(null)}
            lancamentoAtualizado={() => {
              setEditing(null);
              loadRequests();
            }}
          />
        ) : null}
      </Modal>
    </div>
  );
};

export default PedidosSaque;
